import { useTranslations } from '@vocab/react';
import { Text } from 'braid-design-system';

import { LoadingItem } from 'src/components/LoadingBlock/LoadingBlock';

import { useProfileVisibilityOptions } from '../EditProfileVisibility/data';
import { useGetProfileVisibility2 } from '../data';

import translations from './.vocab';

interface Props {
  loading?: boolean;
}

export const ProfileVisibilityStatus = ({ loading }: Props) => {
  const { t } = useTranslations(translations);
  const { profileVisibility2 } = useGetProfileVisibility2();
  const { profileVisibilityOptions } = useProfileVisibilityOptions();

  const id = `profile-visibility-status-${
    profileVisibility2 ? profileVisibility2.id.toLowerCase() : 'not-set'
  }-txt`;

  const labelWhenVisibilityNotSet = t('Set your profile visibility');

  const profileVisibilityStatusLabel = profileVisibility2
    ? profileVisibility2.name
    : labelWhenVisibilityNotSet;

  return (loading ?? !profileVisibilityOptions) ? (
    <LoadingItem type="text" size="standard" width="large" />
  ) : (
    <Text
      id={id}
      data={{ automation: id }}
      tone={profileVisibility2 ? 'neutral' : 'critical'}
    >
      {profileVisibilityStatusLabel}
    </Text>
  );
};
